import React from 'react';
import { Card, CardContent, Typography} from '@mui/material';
import { styled } from '@mui/system';
import { Link } from 'react-router-dom';

const StyledLink = styled(Link)({
    textDecoration: 'none',
    color: 'inherit',
    display: 'block', // This is important to make the link occupy the full space of the Card
});

const Blog = ({ item }) => (
    <StyledLink to={`/blogpost/${item.slugName}`}>
        <Card
            sx={{
                maxWidth: '100%',
                boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.2)',
                backgroundColor: '#f2f2f2',
                borderRadius: '15px',
                padding: '16px',
                transition: 'transform .2s', // Adds a nice hover effect
                '&:hover': {
                    transform: 'scale(1.02)'  // Adds a subtle scale on hover
                },
                border: '2px solid #FFFFFF00'
            }}
        >
            <CardContent>
                <Typography
                    variant="h5"
                    sx={{
                        color:'#333333',
                        marginBottom: '8px',
                        textAlign: 'left',
                    }}
                >
                    {item.title}
                </Typography>
                <Typography
                    variant="body2"
                    color="#9ca3af"
                    sx={{
                        marginBottom: '16px' ,
                        textAlign: 'left'
                }}
                >
                    {item.shortDescription}
                </Typography>
            </CardContent>
        </Card>
    </StyledLink>
);

export default Blog;
